import type { ReactNode } from "react"

import { Label } from "@/components/ui/label.tsx"

/**
 * Shared wrapper for gauge cards (e.g. FlowRateGauge, ForHireGauge).
 *
 * Owns the outer card chrome, header row, subtitle, and inner centering
 * container so all gauge cards render at the same height and spacing.
 */
export default function GaugeCard({
  title,
  subtitle,
  status,
  children,
}: {
  title: string
  subtitle: string
  status?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="rounded-md shadow-sm p-3 border bg-card h-full flex flex-col">
      <div className="flex items-start justify-between gap-2">
        <h2 className="text-lg font-semibold">{title}</h2>
        {status}
      </div>
      <Label className="text-muted-foreground text-[12pt]">{subtitle}</Label>
      <div className="flex flex-col gap-2 mt-2 justify-center grow items-center">{children}</div>
    </div>
  )
}
